import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { History, createBrowserHistory } from 'history';
import { routerReducer, routerMiddleware, RouterState } from "react-router-redux";
import * as SchoolActions from "./SchoolAction";
import * as ActivityActions from "./ActivityAction";
import * as UserAction from "./UserAction";
import * as DutyAction from "./DutyAction";
import * as GroupAction from "./GroupAction";
import * as AuthAction from "./AuthAction";
import * as AppTokenAction from "./AppTokenAction";
import * as DashboardAction from "./DashboardAction";
import * as FilterAction from "./FilterAction";
import * as MenuAction from "./MenuAction";
import * as AuditLogAction from "./AuditLogAction";
import * as MeAction from "./MeAction";
import * as ModuleAction from "./ModuleAction";
import * as InstanceConfigAction from "./InstanceConfigAction";
import * as ScheduleSync_Event from "./ScheduleSync/ScheduleSyncEventAction";
import * as ScheduleSync_User from "./ScheduleSync/ScheduleSyncUserAction";
import * as NotificationAction from "./NotificationAction";
import * as OneRosterDashboard from "./OneRoster/OneRosterDashboardAction";
import * as OneRosterSchoolUnit from "./OneRoster/OneRosterSchoolUnitAction";
import * as OneRosterClass from "./OneRoster/OneRosterClassAction";
import * as OneRosterUser from "./OneRoster/OneRosterUserAction";
import * as Consumers from "./ConsumerAction";
import * as BlobContainer from "./BlobContainerAction";
import * as AdministrationDashboard from "./AdministrationDashboardAction";
import * as DNP from "./DnpAction";
import * as InstancePhase from "./ModuleInstancePhaseAction";
import * as TrackingOperation from './TrackingOperationAction';
import * as PasswordAdmin from "./PasswordAdminAction";
import * as ActivityInformationMarkings from "./ActivityInformationMarkingsAction"
import * as OneRosterTrackingOperation from "./OneRoster/OneRosterTrackingOperationAction";
import * as OneRosterCombineTeam from "./OneRoster/OneRosterCombineTeamAction";
import * as ModuleStopPeriod from "./ModuleStopPeriodAction";
import * as ModuleGracePeriod from "./ModuleGracePeriodAction";
import * as ModuleInstance from './ModuleInstanceAction';
import * as ModuleTrigger from './ModuleTriggerAction';
import * as ObjectLog from './ObjectLogAction';
import * as ModuleStatus from './ModuleStatusAction';
import * as MeitnerExport from './MeitnerExportAction';
import * as OneRosterConfiguration from './OneRoster/OneRosterConfigurationAction';
import * as GoogleDevice from './GoogleDevice/DeviceAction';
import * as GoogleDeviceDashboard from './GoogleDevice/GoogleDeviceDashboardAction';
import * as PasswordChange from './PasswordChangeAction';
import * as PasswordProfile from './PasswordProfileAction';
import * as PasswordAppToken from './PasswordAppTokenAction';
import * as ClassroomAdminClassroom from './ClassroomAdmin/ClassroomAdminClassroomAction'
import * as ClassroomAdminDashboard from './ClassroomAdmin/ClassroomAdminDashboardAction'
import * as ClassroomTools from './ClassroomAdmin/ClassroomToolsAction';


export interface RootState {
    routing: RouterState
    schools: SchoolActions.SchoolUnitState
    activities: ActivityActions.ActivityState
    activityInformationMarkings: ActivityInformationMarkings.InformationMarkingsState
    users: UserAction.UserState,
    groups: GroupAction.GroupState
    duties: DutyAction.DutyState
    auth: AuthAction.AuthState
    token: AppTokenAction.AppTokenState
    dashboard: DashboardAction.DashboardState
    filter: FilterAction.FilterState,
    auditlog: AuditLogAction.AuditLogState
    menu: MenuAction.MenuState
    me: MeAction.MeState
    module: ModuleAction.ModuleState,
    moduleStopPeriod: ModuleStopPeriod.ModuleStopPeriodState,
    moduleGracePeriod: ModuleGracePeriod.ModuleGracePeriodState,
    moduleInstance: ModuleInstance.ModuleInstanceState,
    moduleTrigger: ModuleTrigger.ModuleTriggerState,
    moduleStatus: ModuleStatus.ModuleStatusState,
    instanceSettings: InstanceConfigAction.InstanceConfigState,
    schedulesync_events: ScheduleSync_Event.ScheduleSync_EventState
    schedulesync_users: ScheduleSync_User.ScheduleSyncUserState
    notification: NotificationAction.NotificationState
    onerosterDashboard: OneRosterDashboard.OneRosterDashboardState
    onerosterSchoolunit: OneRosterSchoolUnit.OneRosterSchoolUnitState
    onerosterClass: OneRosterClass.OneRosterClassState
    onerosterUser: OneRosterUser.OneRosterUserState
    consumers: Consumers.ConsumerState
    blob: BlobContainer.BlobContainerState
    admin_dashboard: AdministrationDashboard.AdministrationDashboardState
    dnp: DNP.DnpState,
    instancePhase: InstancePhase.ModuleInstancePhaseState,
    trackingOperation: TrackingOperation.TrackingOperationState,
    passwordAdmin: PasswordAdmin.PasswordAdminState,
    oneRosterTrackingOperation: OneRosterTrackingOperation.OneRosterTrackingOperationState,
    onerosterCombineTeam: OneRosterCombineTeam.OneRosterCombineTeamActionState,
    objectLog: ObjectLog.ObjectLogState,
    meitnerExport: MeitnerExport.MeitnerExportState,
    oneRosterConfiguration: OneRosterConfiguration.OneRosterConfigurationState,
    device: GoogleDevice.DeviceState,
    deviceDashboard: GoogleDeviceDashboard.GoogleDeviceDashboardState,
    passwordChange: PasswordChange.PasswordChangeState,
    classroomAdminClassroom: ClassroomAdminClassroom.ClassroomAdminClassroomState,
    passwordProfile: PasswordProfile.PasswordProfileState,
    passwordAppToken: PasswordAppToken.PasswordAppTokenState,
    classroomAdminDashboard: ClassroomAdminDashboard.ClassroomAdminDashboardState,
    classroomTools: ClassroomTools.ClassroomToolsState,
}
    
declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION__?: Function;
        initialReduxState: RootState
    }
}

function configureStore(history: History, initialState: RootState) {
    const reducers = {
        schools: SchoolActions.reducer,
        activities: ActivityActions.reducer,
        activityInformationMarkings: ActivityInformationMarkings.reducer,
        users: UserAction.reducer,
        groups: GroupAction.reducer,
        duties: DutyAction.reducer,
        auth: AuthAction.reducer,
        token: AppTokenAction.reducer,
        dashboard: DashboardAction.reducer,
        filter: FilterAction.reducer,
        auditlog: AuditLogAction.reducer,
        menu: MenuAction.reducer,
        me: MeAction.reducer,
        module: ModuleAction.reducer,
        moduleStopPeriod: ModuleStopPeriod.reducer,
        moduleGracePeriod: ModuleGracePeriod.reducer,
        moduleInstance: ModuleInstance.reducer,
        moduleTrigger: ModuleTrigger.reducer,
        moduleStatus: ModuleStatus.reducer,
        instanceSettings: InstanceConfigAction.reducer,
        schedulesync_events: ScheduleSync_Event.reducer,
        schedulesync_users: ScheduleSync_User.reducer,
        notification: NotificationAction.reducer,
        onerosterDashboard: OneRosterDashboard.reducer,
        onerosterSchoolunit: OneRosterSchoolUnit.reducer,
        onerosterClass: OneRosterClass.reducer,
        onerosterUser: OneRosterUser.reducer,
        consumers: Consumers.reducer,
        blob: BlobContainer.reducer,
        admin_dashboard: AdministrationDashboard.reducer,
        dnp: DNP.reducer,
        instancePhase: InstancePhase.reducer,
        trackingOperation: TrackingOperation.reducer,
        passwordAdmin: PasswordAdmin.reducer,
        oneRosterTrackingOperation: OneRosterTrackingOperation.reducer,
        onerosterCombineTeam: OneRosterCombineTeam.reducer,
        objectLog: ObjectLog.reducer,
        meitnerExport: MeitnerExport.reducer,
        oneRosterConfiguration: OneRosterConfiguration.reducer,
        device: GoogleDevice.reducer,
        deviceDashboard: GoogleDeviceDashboard.reducer,
        passwordChange: PasswordChange.reducer,
        passwordProfile: PasswordProfile.reducer,
        passwordAppToken: PasswordAppToken.reducer,
        classroomAdminClassroom: ClassroomAdminClassroom.reducer,
        classroomAdminDashboard: ClassroomAdminDashboard.reducer,
        classroomTools: ClassroomTools.reducer,
    };

    const middleware = [thunk, routerMiddleware(history)];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === "development";
    if (isDevelopment && typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const rootReducer = combineReducers({
        ...reducers,
        routing: routerReducer,
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}

export default configureStore(createBrowserHistory(), window.initialReduxState);
